import { isMarketSupported, type ConnectionType } from '@talos/kyoko';
import { useMemo } from 'react';
import { AvailabilityEnum, type AvailabilityCondition } from '../types';

/** A hook wrapper for getMarketSupportedCondition */
export const useMarketSupportedCondition = ({
  connectionType,
}: GetMarketSupportedConditionParams): AvailabilityCondition => {
  return useMemo(() => getMarketSupportedCondition({ connectionType }), [connectionType]);
};

export interface GetMarketSupportedConditionParams {
  connectionType: ConnectionType;
}

/**
 * A AvailabilityCondition asserting that the Market.[ConnectionType] is present (defined) and that Market.[ConnectionType].Status
 * is Supported
 */
export function getMarketSupportedCondition({
  connectionType,
}: GetMarketSupportedConditionParams): AvailabilityCondition {
  return {
    id: 'marketSupported',
    ready: true,
    condition: market => {
      const ok = isMarketSupported(market, connectionType);
      return ok ? { availability: AvailabilityEnum.Ok } : { availability: AvailabilityEnum.Excluded };
    },
  };
}
